module.exports = __webpack_public_path__ + "img/flowPath-item4-on.09512976.png";